export default __webpack_public_path__ + "static/media/03-dynamic.94f1338b.jpg";